import * as types from '@/store/mutation-types'
import api from '@/services/api/adminMail'
import { buildSuccess, handleError } from '@/utils/utils.js'
import { checkIfTokenNeedsRefresh } from '@/utils/utils.js'
import AWS from 'aws-sdk';

const getters = {
  mails: state => state.mails,
  totalMails: state => state.totalMails
}

const S3AccessKey = process.env.VUE_APP_S3_ACCESS_KEY
const S3SecretAccessKey = process.env.VUE_APP_S3_SECRET_ACCESS_KEY

const actions = {
  getMailsHistory({ commit }, payload) {
    checkIfTokenNeedsRefresh()
    commit(types.SHOW_TOP_LOADING, false)
    return new Promise((resolve, reject) => {
      api
        .getMailsHistory(payload)
        .then(response => {
          if (response.status === 200) {
            commit(types.MAILS, response.data.docs)
            commit(types.TOTAL_MAILS, response.data.totalDocs)
            resolve()
          }
        })
        .catch(error => {
          handleError(error, commit, reject)
        })
    })
  },

  async download({ commit }, payload){

    return new Promise((resolve, reject) => {
      api
        .download(payload)
        .then(response => {
          if (response.status === 200) {
            //...
          }
        })
        .catch(error => {
          handleError(error, commit, reject)
        })
    })
  },
  async uploadToS3AndTest({ commit }, payload){
      checkIfTokenNeedsRefresh()
      commit(types.SHOW_LOADING, true)
      const shouldSend = await actions.uploadToS3({
        Bucket: payload.Bucket,
        Key: payload.Key,
        ACL: payload.ACL,
        Body: payload.Body
      })

      if(shouldSend){

        let payloadTest = {
          identity: payload.identity,
          subject: payload.subject,
          text: payload.text,
          image: payload.image,
          button: payload.button,
          emails: payload.emails
        }
        if(payload.button.label.length === 0){ delete payloadTest.button } // email sem botão
        if(payload.image === "/"){ delete payloadTest.image } // email sem imagem

        await actions.sendTest({ commit }, payloadTest)
      }
  },


  async uploadToS3AndSend({ commit }, payload){

      checkIfTokenNeedsRefresh()
      commit(types.SHOW_LOADING, true)
      const shouldSend = await actions.uploadToS3({
        Bucket: payload.Bucket,
        Key: payload.Key,
        ACL: payload.ACL,
        Body: payload.Body
      })

      if(shouldSend){

        let payloadSend = {
          identity: payload.identity,
          subject: payload.subject,
          text: payload.text,
          image: payload.image,
          button: payload.button,
          campaignName: payload.campaignName
        }
        if(payload.button.label.length === 0){ delete payloadSend.button } // email sem botão
        if(payload.image === "/"){ delete payloadSend.image } // email sem imagem

        await actions.sendMail({ commit }, payloadSend)
      }
  },

  uploadToS3(paramsS3){
    return new Promise((resolve, reject) => {

      if(paramsS3.Body == ""){ // não existe imagem para enviar
        //console.log('não existe imagem para enviar')
        resolve(true)
      }else{ // existe imagem para enviar
        //console.log('existe imagem para enviar')
        const s3 = new AWS.S3();

        s3.config.update({ accessKeyId: S3AccessKey, secretAccessKey: S3SecretAccessKey });
        s3.config.region = 'us-east-1';

        // start upload
        //s3.putObject(paramsS3, function(err, data){
        s3.putObject(paramsS3, function(err){
          if (err){
            //console.log('Falha: '+err)
            reject(false)
          }
          else{
            //console.log("Imagem cadastrada com sucesso.")
            resolve(true)
          }
        })
      }
    })
  },

  deleteFromS3(paramsS3Del){
    const s3 = new AWS.S3();
    s3.config.update({ accessKeyId: S3AccessKey, secretAccessKey: S3SecretAccessKey });
    //s3.config.update({ accessKeyId: "AKIAIWMEXE4C5N623QAA", secretAccessKey: "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" });
    s3.config.region = 'us-east-1';
    //s3.deleteObject(paramsS3Del, function(err, data){
    s3.deleteObject(paramsS3Del, function(err){
      if (err){
        //console.log('Falha: '+err)
      }
      else{
        //console.log("Arquivo excluído com sucesso")
      }
    })
  },

  sendTest({ commit }, payload){
    checkIfTokenNeedsRefresh()
    return new Promise((resolve, reject) => {
    api
      .sendTest(payload)
      .then(response => {

        if (response.status === 200) {
          buildSuccess(
            {msg: 'common.SENT_SUCCESSFULLY'}, commit, resolve
          )
        }
      })
      .catch(error => {
        //console.log('Falha ao enviar email. Excluindo arquivo...')
        actions.deleteFromS3({
          Bucket: payload.Bucket,
          Key: payload.Key
        })
        handleError(error, commit, reject)
      })
    })
  },
  sendMail({ commit }, payload){
    checkIfTokenNeedsRefresh()
    return new Promise((resolve, reject) => {
    api
      .sendMail(payload)
      .then(response => {

        if (response.status === 200) {
          buildSuccess(
            {msg: 'common.SENT_SUCCESSFULLY'}, commit, resolve
          )
        }
      })
      .catch(error => {
        //console.log('Falha ao enviar email. Excluindo arquivo...')
        actions.deleteFromS3({
          Bucket: payload.Bucket,
          Key: payload.Key
        })
        handleError(error, commit, reject)
      })
    })
  },
}

const mutations = {
  [types.MAILS](state, mails) {
    state.mails = mails
  },
  [types.TOTAL_MAILS](state, value) {
    state.totalMails = value
  }
}

const state = {
  mails: [],
  totalMails: 0
}
export default {
  state,
  getters,
  actions,
  mutations
}
